// src/components/PracticeTest/Skeleton.jsx
 
 import React from 'react';
export default function Skeleton({ count = 3 }) { 
    return (
      <div style={{ display: 'grid', gap: '20px', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))' }}>
        {Array.from({ length: count }).map((_, i) => (
          <div key={i} style={{ height: '80px', backgroundColor: '#f1f5f9', borderRadius: '12px', animation: 'pulse 1.5s infinite' }} />
        ))}
      </div>
    ); 
}